import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: '_id',
  })

  return {
    variables: {
      patient_id,
    },
    requestPolicy: 'network-only',
  }
}
